
export const getAllCurrencies = (state) => state.allCurrencies
export const getAppCurrencies = (state) => state.appCurrencies
export const getDefaultCurrency = (state) => state.default
export const getCurrencies = (state) => state.currencies
export const getCurrenciesMeta =  (state) => state.metaData
